import axiosInstance from '@/store/axios'
import { rejectErrorApi } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    assets ({ commit }, params) {
      return axiosInstance.get('/api/v1/assets', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    getAssetById ({ commit, state }, params) {
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/assets/${params.id}`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    assetCount ({ commit }, params) {
      return axiosInstance.get('/api/v1/assets/$count', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateAsset ({ dispatch }, asset) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/assets/${asset.id}`,
        data: asset,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    removeAssets ({ dispatch }, selected) {
      return axiosInstance.post('/api/v1/assets/commands/bulk-remove', selected)
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    getAssetData ({ dispatch }, asset) {
      return axiosInstance.get(`/asset/data/${asset.id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data.asset
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getAssets ({ dispatch }, params) {
      return axiosInstance.get('/asset/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getAsset ({ commit }, id) {
      return axiosInstance.get(`/asset/data/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data.asset
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getAssetPrograms ({ dispatch }, params) {
      return axiosInstance.get('/schedule/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data.programs
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    removeAsset ({ dispatch }, asset) {
      return axiosInstance.get(`/asset/remove/${asset.id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return true
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    createPackage ({ dispatch }, asset) {
      return axiosInstance.post('/asset/package/create', asset)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data.asset
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    updatePackage ({ dispatch }, asset) {
      return axiosInstance.post('/asset/package/update', asset)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data.asset
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    uploadAssetPoster ({ dispatch }, file) {
      return axiosInstance.post('/asset/upload-poster', file, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return true
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getGenres ({ dispatch }, data) {
      if (!data) {
        // eslint-disable-next-line no-param-reassign
        data = {}
      }

      const params = {
        limit: data.limit || 100,
        offset: data.offset || 0,
        sort: data.sort || 'order',
      }

      return axiosInstance.get('/genre/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data.genres
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getCategories ({ dispatch }, data) {
      if (!data) {
        // eslint-disable-next-line no-param-reassign
        data = {}
      }

      const params = {
        limit: data.limit || 100,
        offset: data.offset || 0,
        sort: data.sort || 'order',
      }

      return axiosInstance.get('/category/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return result.data.categories
        })
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    transcodeAsset ({ dispatch }, asset) {
      return axiosInstance.post('/asset/transcode', asset)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result)
          }
          return true
        })
        .catch((error) => Promise.reject(error))
    },
  },
}
